var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.ready
        ? _c("data-table", {
            ref: "table",
            staticClass: "table table-striped",
            attrs: {
              columns: _vm.columns,
              data: _vm.issues,
              loading: _vm.loading,
              datatableOptions: _vm.datatableOptions
            },
            on: {
              clicked: function($event) {
                return _vm.openSummary($event)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("modal", {
        ref: "summary",
        attrs: { options: { minHeight: 200 } },
        on: {
          hidden: function($event) {
            _vm.summary = null
          }
        },
        scopedSlots: _vm._u([
          {
            key: "modal-title",
            fn: function() {
              return [
                _c("h3", [
                  _c("i", { staticClass: "fas fa-info-circle" }),
                  _vm._v(" " + _vm._s(_vm.summary.title))
                ])
              ]
            },
            proxy: true
          },
          {
            key: "modal-body",
            fn: function() {
              return [
                _c("span", {
                  domProps: { innerHTML: _vm._s(_vm.summary.body) }
                })
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }